import confetti from "canvas-confetti";

export const launchConfetti = () => {
  confetti({
    particleCount: 200,
    spread: 90,
    origin: { x: 0.9, y: 0.3 },
    colors: ["#7CC3AE", "#86A0CC", "#8F68F5", "#042B5F"],
  });
};
